import React, { useEffect } from "react";
import { useState } from "react";
import "./index.css";
import { Formik } from "formik";
import { Button, Form, FormGroup, Table } from "reactstrap";
import * as Yup from "yup";
import SvgImage from "../Icons/Icons";
import {
  editTripExpenseAction,
  getDistance,
  getLRList,
  getSavedAddress,
} from "../../services/Store/Actions/TripsAction";
import { storeDataToAsyncStorage } from "../../services/Utils/functions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { v4 as uuid } from "uuid";
import { toastStatus } from "../../services/Store/Actions/appActions";
import { Switch } from "@material-ui/core";
import { styled } from "@mui/material/styles";
import { omcVehicleBalanceAction } from "../../services/Store/Actions/omcActions";
import { getWalletBalAction } from "../../services/Store/Actions/LogipeCardActions";
import { getVendorDetailsAction } from "../../services/Store/Actions/beneficiaryAction";
import AddLr from "../TripsMainV2/Components/AddLr";
import ChooseRoute from "../LoadReceipt/Components/ChooseRoute";
import AddAddress from "../LoadReceipt/Components/AddAddress";
import AddDriverV2 from "../TripsMainV2/Components/AddDriverV2";
import AddVehicleV2 from "../TripsMainV2/Components/AddVehicleV2";
import { getVehicleListAction } from "../../services/Store/Actions/manageVehicleAction";
import { getDriverList } from "../../services/Store/Actions/driverslistActions";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    left: "5px",
    top: "7px",
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "rgb(46, 124, 123)",
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="10" width="10" viewBox="0 0 448 512"><path fill="${encodeURIComponent(
          "#fff"
        )}" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>')`,
        left: 0,
        top: 0,
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    width: 20,
    height: 20,
    "&::before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="10" width="10" viewBox="0 0 512 512"><path fill="${encodeURIComponent(
        "rgb(0, 0, 0)"
      )}" d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V256c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM143.5 120.6c13.6-11.3 15.4-31.5 4.1-45.1s-31.5-15.4-45.1-4.1C49.7 115.4 16 181.8 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240c0-74.2-33.8-140.6-86.6-184.6c-13.6-11.3-33.8-9.4-45.1 4.1s-9.4 33.8 4.1 45.1c38.9 32.3 63.5 81 63.5 135.4c0 97.2-78.8 176-176 176s-176-78.8-176-176c0-54.4 24.7-103.1 63.5-135.4z"/></svg>')`,
      left: 0,
      top: 0,
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
    borderRadius: 20 / 2,
  },
}));
function CreateTrip(props) {
  const { sideBar } = props;
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [routeData, setRouteData] = useState({});
  const [advancePayment, setAdvancePayment] = useState();
  const [openHeader, setOpenHeader] = useState(false);
  const [tripData, setTripData] = useState({});
  const [tripExpense, setTripExpense] = useState({});
  const [selectedIndexHeader, setSelectedIndexHeader] = useState(0);
  const [fuelVandor, setFuelVandor] = useState({});
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [freight, setFreight] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const [chooseRouteModal, setChooseRouteModal] = useState(false);
  const [createTripModal, setCreateTripModal] = useState(false);
  const [search, setSearch] = useState("");
  const [search1, setSearch1] = useState("");
  const [search2, setSearch2] = useState("");
  const [search3, setSearch3] = useState("");
  const [color1, setColor1] = useState(-1);
  const [color2, setColor2] = useState(-1);
  const [sourcePincode, setSourcePincode] = useState("");
  const [destPincode, setDestPincode] = useState("");
  const [addressModal, setAddressModal] = useState(false);
  const [display1, setDisplay1] = useState(false);
  const [display2, setDisplay2] = useState(false);
  const [driver, setdriver] = useState(false);
  const [driverUserId, setdriverUserId] = useState("");
  const [vehicle, setVehicle] = useState(false);
  const [distanceCal, setDistanceCal] = useState(0);
  const [searchDriver, setSearchDriver] = useState("");
  const [display3, setDisplay3] = useState(false);
  const [addStop, setAddStop] = useState(false);
  const [newStop, setNewStop] = useState({});
  const [list, setList] = useState([]);
  const [showStops, setShowStops] = useState(false);
  const [openDelayReason, setDelayReason] = useState(false);
  const balanceRecord = useSelector(
    (state) => state?.LogipeCard?.balanceRecord
  );
  const { savedAddresses } = useSelector((state) => state?.trip);
  const validationSchema = Yup.object().shape({
    // tripNo: Yup.string()
    //     .required("TripNo is required"),
    source: Yup.string().required("Source is required"),

    destination: Yup.string().required("Destination is required"),

    fleetId: Yup.string().required("Vehicle is required"),

    driverUserId: Yup.string().required("Driver is required"),

    startDate: Yup.string().required("StartDate is required"),
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const paymentType = {
    Fuel: [{ value: "Vendor" }, { value: "Diesel Wallet" }],
    Driver: [{ value: "Card" }],
    Fastag: [{ value: "Fastag" }],
    Vendor: [{ value: "Vendor" }],
    Cash: [
      { value: "Food" },
      { value: "Service" },
      { value: "Fuel" },
      { value: "Salary" },
      { value: "Fastag" },
      { value: "Others" },
    ],
  };
  const allFleets = useSelector(
    (state) => state?.manageVehicle?.allFleets?.rows
  );
  const vehCount = useSelector(
    (state) => state?.manageVehicle?.allFleets?.count
  );
  const driverList = useSelector(
    (state) => state?.driverlist?.allDrivers?.divers?.rows
  );
  const driverCount = useSelector(
    (state) => state?.driverlist?.allDrivers?.divers?.count
  );
  let Earnings = 0;
  let Expenses = 0;

  for (let index = 0; index < selectedRow?.length; index++) {
    Earnings = Earnings + selectedRow?.[index]?.freightAmount;
  }
  for (let index = 0; index < advancePayment?.length; index++) {
    console.log("wqefghnewqrgh", advancePayment);
    Expenses = Expenses + parseInt(advancePayment?.[index]?.expacted || 0);
  }
  const paymentTypeV2 = ["Fuel", "Fastag", "Cash"];
  const paymentValues = [
    {
      header: "Fuel",
      // type: tripExpense?.fuelFinalMode == 3 ? "OMC" : "Vendor" || "",
      type: "",
      vendor: tripExpense?.fuelFinalMode == 3 ? null : fuelVandor,
      expacted: tripExpense?.fuelTotal || "0",
      advance: tripExpense?.fuelAdvance || "0",
      totalExpense: tripExpense?.totalFuelExpense || "0",
      autoAdvance: false,
      autoFinal: false,
      advanceStatus: tripExpense?.fuelAdvanceStatus || false,
      payable:
        parseInt(tripExpense?.fuelTotal || 0) -
          parseInt(tripExpense?.totalFuelExpense || 0) || "0",
    },
    {
      id: uuid(),
      header: "Cash",
      type: "",
      vendor: null,
      givenTo: "",
      expacted: "0",
      advance: "0",
      totalExpense: "0",
      payable: "0",
      key: "",
      autoAdvance: false,
      autoFinal: false,
      expactedStatus: 0,
      advanceStatus: 0,
    },
    {
      header: "Fastag",
      type: "",
      vendor: {},
      expacted: tripExpense?.fastagTotal || "0",
      advance: tripExpense?.fastagAdvance || "0",
      advanceStatus: tripExpense?.fastagStatus || false,
      totalExpense: tripExpense?.totalFastagExpense || "0",
      autoAdvance: false,
      autoFinal: false,
      payable:
        parseInt(tripExpense?.fastagTotal || 0) -
          parseInt(tripExpense?.totalFastagExpense || 0) || "0",
    },
  ];
  const addDriver = () => setdriver(!driver);
  const addVehicle = () => setVehicle(!vehicle);
  const addAddress = () => setAddressModal(!addressModal);
  const chooseRouteModalToggle = () => setChooseRouteModal(!chooseRouteModal);
  const createTripModalToggle = () => setCreateTripModal(!createTripModal);

  let handleChangeField = (i, e, field = null) => {
    console.log(
      "pppoooooooooo",
      field,
      e.target.value,
      i,
      advancePayment,
      field
    );
    let newFormValues = [...advancePayment];
    if (field && newFormValues[i]["header"]) {
      newFormValues[i][field] =
        e.target.value == "true"
          ? true
          : e.target.value == "false"
          ? false
          : e.target.value;
    } else if (!newFormValues[i]["header"]) {
      let isExist = newFormValues?.find(
        (x) => x?.header == e.target.value && e.target.value != "Cash"
      );
      if (isExist) return;
      let val = paymentValues?.find((v) => v?.header == e.target.value);
      // console.log("pppoooooooooorrrrr", val);
      if (val) {
        // console.log("pppoooooooooo", e.target.value, i,val);
        newFormValues[i] = val;
        // newFormValues.push(val)
      }
    }
    setAdvancePayment(newFormValues);
    // newFormValues.push()
    // newFormValues[i][e.target.name] = e.target.value;
    // setAdvancePayment(newFormValues);
  };
  let addFormFields = () => {
    setAdvancePayment([
      ...advancePayment,
      // {
      //   id: uuid(),
      //   header: "Cash",
      //   type: "",
      //   vendor: null,
      //   expacted: "0",
      //   advance: "0",
      //   key: "",
      //   payable: "0",
      //   totalExpense: "0",
      //   onPayAdvance: () => {
      //     setOpen6(true);
      //   },
      //   expactedStatus: 0,
      //   advanceStatus: 0,
      // },
      {
        header: "",
        type: "",
        vendor: {},
        expacted: tripExpense?.fastagTotal || "0",
        advance: tripExpense?.fastagAdvance || "0",
        advanceStatus: tripExpense?.fastagStatus || false,
        totalExpense: tripExpense?.totalFastagExpense || "0",
        payable:
          parseInt(tripExpense?.fastagTotal || 0) -
            parseInt(tripExpense?.totalFastagExpense || 0) || "0",
      },
    ]);
  };
  let removeFormFields = (index) => {
    const newFormValues = advancePayment.filter((item, i) => {
      return index != i;
    });
    console.log("newFormValues", newFormValues);
    setAdvancePayment(newFormValues);
  };
  let removeSelectedRow = (index) => {
    const newFormValues = selectedRow.filter((item, i) => {
      return index != i;
    });
    console.log("newFormValues", newFormValues);
    setSelectedRow(newFormValues);
  };
  const addFreight = () => {
    setFreight(!freight);
  };
  const vendorDetails = useSelector(
    (state) => state?.beneficiary?.vendorDetails
  );
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const handleDragEnd = ({ destination, source }) => {
    if (!destination) return;
    console.log("dfsalistliliststda", list);
    setList(reorder(list, source.index, destination.index));
  };
  useEffect(() => {
    if (display3 == true) {
      dispatch(
        getSavedAddress({ address: search3 }, (res) => {
          console.log("getSavedAddress", res);
        })
      );
    }
  }, [display3, search3]);
  useEffect(() => {
    if (display1 == true) {
      // dispatch(findTripAddressV2({},(res)=>{
      //   console.log("findTripAddressV2",res);
      // }))
      dispatch(
        getSavedAddress({ address: search1 }, (res) => {
          console.log("getSavedAddress", res);
        })
      );
    }
  }, [display1, search1]);
  useEffect(() => {
    if (display2 == true) {
      dispatch(
        getSavedAddress({ address: search2 }, (res) => {
          console.log("getSavedAddress", res);
        })
      );
    }
  }, [display2, search2]);
  useEffect(() => {
    dispatch(
      getVehicleListAction({
        offset: "",
        search: search,
        minKyc: "",
        sortAs: "",
        sortBy: "",
        limit: 10,
      })
    );
  }, [search]);
  useEffect(() => {
    dispatch(
      getDriverList({
        offset: "",
        search: searchDriver,
        minKyc: "",
        sortAs: "",
        sortBy: "",
        limit: 10,
      })
    );
  }, [searchDriver]);
  useEffect(() => {
    if (driverUserId) dispatch(getWalletBalAction(driverUserId));
  }, [driverUserId]); 
  useEffect(() => {
    dispatch(
      getLRList({ offset: 0, limit: 5 }, (res) => {
        console.log("rerere", res);
      })
    );
  }, []);
  useEffect(() => {
    if (
      routeData?.fromAddressRoute?.addressId &&
      routeData?.toAddressRoute?.addressId
    ) {
      setSourcePincode(routeData?.fromAddressRoute?.pincode);
      setDestPincode(routeData?.toAddressRoute?.pincode);
      dispatch(
        getDistance(
          {
            source: routeData?.fromAddressRoute?.pincode,
            des: routeData?.toAddressRoute?.pincode,
          },
          (res) => {
            if (res?.status == 200) {
              console.log("ppssspppppppp", res?.data?.data?.distanceCal);
              setDistanceCal(res?.data?.data?.distanceCal);
            }
          }
        )
      );
    } else if (
      selectedRow?.[0]?.toAddress?.addressId &&
      selectedRow?.[0]?.fromAddress?.addressId
    ) {
      setSourcePincode(selectedRow?.[0]?.fromAddress?.pincode);
      setDestPincode(selectedRow?.[0]?.toAddress?.pincode);
      dispatch(
        getDistance(
          {
            source: selectedRow?.[0]?.toAddress?.pincode,
            des: selectedRow?.[0]?.fromAddress?.pincode,
          },
          (res) => {
            if (res?.status == 200) {
              console.log("ppssspppppppp", res?.data?.data?.distanceCal);
              setDistanceCal(res?.data?.data?.distanceCal);
            }
          }
        )
      );
    }
  }, []);
  useEffect(() => {
    if (tripData.userId) dispatch(getWalletBalAction(tripData.userId));
    dispatch(omcVehicleBalanceAction(tripData?.fleetId));
    if (tripData?.vendorId)
      dispatch(getVendorDetailsAction({ id: tripData?.vendorId }));
    let xxx = [
      // {
      //   header: "Fuel",
      //   type: tripExpense?.fuelFinalMode == 3 ? "OMC" : "Vendor" || "",
      //   vendor: tripExpense?.fuelFinalMode == 3 ? null : fuelVandor,
      //   expacted: tripExpense?.fuelTotal || "0",
      //   advance: tripExpense?.fuelAdvance || "0",
      //   totalExpense: tripExpense?.totalFuelExpense || "0",
      //   onPayAdvance: () => {
      //     loadOmc();
      //   },
      //   advanceStatus: tripExpense?.fuelAdvanceStatus || false,
      //   payable:
      //     parseInt(tripExpense?.fuelTotal || 0) -
      //       parseInt(tripExpense?.totalFuelExpense || 0) || "0",
      // },
      {
        header: "Driver",
        type: "Card",
        vendor: {},
        expacted: tripExpense?.driverTotal || routeData?.driverExpected || "0",
        advance: tripExpense?.driverAdvance || routeData?.driverAdvance || "0",
        totalExpense:
          tripExpense?.totalDriverExpense || routeData?.driverFinal || "0",
        advanceStatus: tripExpense?.driverAdvanceStatus || false,
        payable:
          parseInt(tripExpense?.driverTotal || 0) -
            parseInt(tripExpense?.totalDriverExpense || 0) ||
          routeData?.driverFinal ||
          "0",
        autoAdvance: tripExpense?.autoDriverAdvance || false,
        autoFinal: tripExpense?.autoDriverFinal || false,
      },

      // {
      //   header: "Fastag",
      //   type: "Fastag",
      //   vendor: {},
      //   expacted: tripExpense?.fastagTotal || routeData?.fastagExpected || "0",
      //   advance: tripExpense?.fastagAdvance || routeData?.fastagExpected || "0",
      //   advanceStatus: tripExpense?.fastagStatus || false,
      //   totalExpense: tripExpense?.totalFastagExpense || "0",
      //   onPayAdvance: () => {
      //     setOpen4(true);
      //   },
      //   payable:
      //     parseInt(tripExpense?.fastagTotal || 0) -
      //       parseInt(tripExpense?.totalFastagExpense || 0) || "0",
      // },
    ];
    // if (tripData?.vendorId && vendorDetails) {
    //   console.log("fleetVendor2", vendorDetails);
    //   xxx.push({
    //     header: "Vendor",
    //     type: "Vendor",
    //     vendor: vendorDetails,
    //     expacted: tripExpense?.vendorTotal || routeData?.ownerExpected || "0",
    //     advance: tripExpense?.vendorAdvance || routeData?.ownerAdvance || "0",
    //     advanceStatus: tripExpense?.vendorAdvanceStatus || false,
    //     totalExpense: tripExpense?.totalVendorExpanse || "0",
    //     payable:
    //       parseInt(tripExpense?.vendorTotal || 0) -
    //         parseInt(tripExpense?.totalVendorExpanse || 0) || "0",
    //     autoAdvance: tripExpense?.autoVendorAdvance || false,
    //     autoFinal: tripExpense?.autoVendorFinal || false,
    //   });
    // }

    if (
      routeData?.fastagAdvance ||
      routeData?.fastagExpected ||
      routeData?.fastagFinal
    ) {
      xxx.push({
        header: "Fastag",
        type: "Fastag",
        vendor: {},
        expacted: tripExpense?.fastagTotal || routeData?.fastagExpected || "0",
        advance: tripExpense?.fastagAdvance || routeData?.fastagAdvance || "0",
        advanceStatus: tripExpense?.fastagStatus || false,
        totalExpense:
          tripExpense?.totalFastagExpense || routeData?.fastagFinal || "0",
        payable:
          parseInt(tripExpense?.fastagTotal || 0) -
            parseInt(tripExpense?.totalFastagExpense || 0) || "0",
        autoAdvance: tripExpense?.autoFastagAdvance || false,
        autoFinal: tripExpense?.autoFastagFinal || false,
      });
    }

    if (
      routeData?.fuelAdvance ||
      routeData?.fuelExpected ||
      routeData?.fuelFinal
    ) {
      xxx.push({
        header: "Fuel",
        type:
          tripExpense?.fuelAdvanceMode == 4 ? "Vendor" : "Diesel Wallet" || "",
        vendor: tripExpense?.fuelAdvanceMode == 4 ? fuelVandor : null,
        expacted: tripExpense?.fuelTotal || routeData?.fuelExpected || "0",
        advance: tripExpense?.fuelAdvance || routeData?.fuelAdvance || "0",
        totalExpense:
          tripExpense?.totalFuelExpense || routeData?.fuelFinal || "0",
        autoAdvance: tripExpense?.autoFuelAdvance || false,
        autoFinal: tripExpense?.autoFuelFinal || false,
        advanceStatus: tripExpense?.fuelAdvanceStatus || false,
        payable:
          parseInt(tripExpense?.fuelTotal || 0) -
            parseInt(tripExpense?.totalFuelExpense || 0) || "0",
      });
    }
    if (tripExpense?.cashData?.length > 0) {
      console.log(
        "tripExpense?.cashData22",
        xxx,
        tripExpense?.cashData?.length
      );
      tripExpense?.cashData.map((e) => {
        e["payable"] =
          parseInt(e?.expacted || 0) - parseInt(e?.totalExpense || 0) || "0";
      });
      console.log(
        "tripExpense?.cashData221",
        tripExpense?.cashData,
        tripExpense?.cashData?.length
      );
      xxx = [...xxx, ...tripExpense?.cashData];
    }
    setAdvancePayment(xxx);
  }, [tripExpense, routeData]);
  return (
    <div
      className="container topMargin sideBarMargin"
      style={{
        // paddingTop:"5.5rem",
        marginLeft: sideBar ? "220px" : "100px",
        maxWidth: sideBar ? windowWidth - 240 : windowWidth - 130,
      }}
    >
      <div
        className="main1"
        style={{ height: "1200px", backgroundColor: "white" }}
      >
        <div>
          <h1
            className=" semiBold"
            style={{ marginBottom: "25px", fontSize: "20px" }}
          >
            Create Trip
          </h1>
        </div>
        <Formik
          enableReinitialize
          validationSchema={validationSchema}
          initialValues={{
            vrn: "",
            driver: "",
            tripNo: "",
            source: "",
            destination: "",
            userId: "",
            expectedStartTime: "",
            expectedDistanceKM: "",
            expectedEndTime: "",
            routeName: routeData?.name || "",
          }}
          onSubmit={(values, actions) => {
            console.log("sdsadsad", values);
            actions.resetForm();
          }}
        >
          {({
            handleBlur,
            handleChange,
            handleSubmit,
            values,
            touched,
            isValid,
            errors,
            setFieldValue,
            resetForm,
          }) => (
            <Form onSubmit={handleSubmit}>
              <FormGroup
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  gap: "50px",
                }}
              >
                <FormGroup>
                  <label for="tripNo" className="heading3 semiBold">
                    Trip No
                  </label>
                  <div className="custNamepadd3">
                    <input
                      className={`inputBoxCust1 ${
                        touched.tripNo && errors.tripNo ? "is-invalid" : ""
                      }`}
                      type="text"
                      id="tripNo"
                      name="tripNo"
                      touched={touched.tripNo}
                      errors={errors.tripNo}
                      onChange={(event) => {
                        // setSearch(event.target.value);
                        setFieldValue("tripNo", event.target.value, true);
                      }}
                      // onBlur={handleBlur("vrn")}
                      // onChange={(event) => {}}
                      value={values.tripNo}
                      // autoFocus
                      placeholder="Enter Trip No"
                      autocomplete="off"
                      // onFocus={() => {}}
                      // onBlur={() => {}}
                    />
                  </div>
                </FormGroup>
                <FormGroup>
                  <label for="routeName" className="heading3 semiBold">
                    Select Route
                  </label>
                  <div className="custNamepadd3 d-flex">
                    <input
                      type="text"
                      id="routeName"
                      className={`inputBoxCust1 ${
                        touched.routeName && errors.routeName
                          ? "is-invalid"
                          : ""
                      }`}
                      name="routeName"
                      // onChange={handleChange("tripNo")}
                      onClick={chooseRouteModalToggle}
                      value={values.routeName}
                      onChange={(e) => {
                        setFieldValue("routeName", e.target.value, true);
                      }}
                      touched={touched.routeName}
                      errors={errors.routeName}
                      placeholder="Enter Route Name"
                      autocomplete="off"
                    />
                    <div
                      style={{
                        marginLeft: "30px",
                        alignContent: "center",
                        textDecorationLine: "underline",
                        cursor: "pointer",
                      }}
                      onClick={chooseRouteModalToggle}
                    >
                      + Add Route
                    </div>
                  </div>
                </FormGroup>
              </FormGroup>
              <div
                className="d-flex justify-content-between"
                style={{ alignItems: "center" }}
              >
                <div>
                  <div className="d-flex justify-content-between" style={{}}>
                    <div
                      className="PGCollectiontTex"
                      style={{ fontSize: "20px" }}
                    >
                      Freights
                    </div>
                    <div
                      className=""
                      style={{
                        fontSize: "18px",
                        color: "#4D5073",
                        padding: "2px 16px 2px 16px",
                        borderWidth: "1px",
                        borderColor: "#4D5073",
                        border: "1px solid",
                        borderRadius: "6px",
                        cursor: "pointer",
                      }}
                      onClick={addFreight}
                    >
                      Add Freights
                    </div>
                  </div>
                  <div style={{ marginTop: "20px", marginBottom: "24px" }}>
                    <Table
                      className="TripSectionTable"
                      bordered="true"
                      id="driver_tables" //
                      style={{ marginTop: "20px" }}
                    >
                      <thead>
                        <tr className="table-header-trip p-0 align-middle text-center">
                          {/* <th className="p-0" style={{ width: "15%" }}>
                              <div style={{ textAlignLast: "center" }}>For</div>{" "}
                            </th> */}
                          <th
                            className="p-0"
                            style={{
                              width: "5%",
                              textAlignLast: "center",
                            }}
                          ></th>
                          <th
                            className="p-0"
                            style={{
                              width: "20%",
                              textAlignLast: "center",
                            }}
                          >
                            Lr No
                          </th>
                          <th
                            className="p-0"
                            style={{
                              width: "25%",
                              textAlignLast: "center",
                            }}
                          >
                            Consignor
                          </th>
                          <th
                            className="p-0"
                            style={{
                              width: "25%",
                              textAlignLast: "center",
                            }}
                          >
                            Consignee
                          </th>
                          <th
                            className="p-0"
                            style={{
                              width: "25%",
                              textAlignLast: "center",
                            }}
                          >
                            Transporter
                          </th>
                          <th
                            className="p-0"
                            style={{
                              width: "20%",
                              textAlignLast: "center",
                            }}
                          >
                            From
                          </th>
                          <th
                            className="p-0"
                            style={{
                              width: "20%",
                              textAlignLast: "center",
                            }}
                          >
                            To
                          </th>
                          <th
                            className="p-0"
                            style={{
                              width: "25%",
                              textAlignLast: "center",
                            }}
                          >
                            Amount
                          </th>
                          <th
                            className="p-0"
                            style={{
                              width: "25%",
                              textAlignLast: "center",
                            }}
                          ></th>
                          <th
                            className="p-0"
                            style={{
                              width: "5%",
                              textAlignLast: "center",
                            }}
                          ></th>
                        </tr>
                      </thead>
                      <tbody className="lowerBorderLineCust">
                        {selectedRow?.map((items, index) => {
                          console.log("---------sdasdadadadasd--", items);
                          let type = items?.type;
                          return (
                            <tr
                              className="table-row-manage-trip-new text4 align-middle text-center p-0"
                              id="addr0"
                              key={index}
                              onClick={() => {
                                // window.location = "/Customers/" + 1;
                                //   navigate("/Customers/" + 1);
                              }}
                            >
                              <td
                                className="p-0"
                                style={{
                                  width: "5%",
                                  borderLeft: "1px solid transparent",
                                  // alignContent: "end",
                                  textAlignLast: "end",
                                  borderBottomColor: "#6C6C6C33",
                                  borderBottomWidth: "1px",
                                  borderStyle: "solid",
                                  fontSize: "14px",
                                }}
                              >
                                {index + 1}
                              </td>
                              <td
                                style={{
                                  width: "20%",

                                  borderRight: " 1px solid transparent",
                                  borderBottomColor: "#6C6C6C33",
                                  borderBottomWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                className="p-0"
                              >
                                <div
                                  className=""
                                  style={{ textAlignLast: "center" }}
                                >
                                  {items.lrNo}
                                </div>
                              </td>
                              <td
                                style={{
                                  width: "25%",
                                  borderLeft: "1px solid transparent",
                                  borderRight: " 1px solid transparent",
                                  borderBottomColor: "#6C6C6C33",
                                  borderBottomWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                className="p-0"
                              >
                                <div
                                  className=""
                                  style={{ textAlignLast: "center" }}
                                >
                                  {items.consignorName || "-"}
                                </div>
                              </td>

                              <td
                                style={{
                                  width: "25%",
                                  borderLeft: "1px solid transparent",
                                  borderRight: " 1px solid transparent",
                                  borderBottomColor: "#6C6C6C33",
                                  borderBottomWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                className="p-0"
                              >
                                <div
                                  className=""
                                  style={{ textAlignLast: "center" }}
                                >
                                  {items.consigneeName || "-"}
                                </div>
                              </td>
                              <td
                                style={{
                                  width: "25%",
                                  borderLeft: "1px solid transparent",
                                  borderRight: " 1px solid transparent",
                                  borderBottomColor: "#6C6C6C33",
                                  borderBottomWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                className="p-0"
                              >
                                <div
                                  className=""
                                  style={{ textAlignLast: "center" }}
                                >
                                  {items.transportorName || "-"}
                                </div>
                              </td>
                              <td
                                style={{
                                  width: "20%",
                                  borderLeft: "1px solid transparent",
                                  borderRight: " 1px solid transparent",
                                  borderBottomColor: "#6C6C6C33",
                                  borderBottomWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                className="p-0"
                              >
                                <div
                                  className=""
                                  style={{ textAlignLast: "center" }}
                                >
                                  {items.fromAddress?.cityName || "-"}
                                </div>
                              </td>
                              <td
                                style={{
                                  width: "20%",
                                  borderLeft: "1px solid transparent",
                                  borderRight: " 1px solid transparent",
                                  justifyContent: "center",
                                  borderBottomColor: "#6C6C6C33",
                                  borderBottomWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                className="p-0"
                              >
                                <div
                                  className=""
                                  style={{ textAlignLast: "center" }}
                                >
                                  {items.toAddress?.cityName || "-"}
                                </div>
                              </td>
                              <td
                                style={{
                                  width: "25%",
                                  borderLeft: "1px solid transparent",
                                  borderRight: " 1px solid transparent",
                                  justifyContent: "center",
                                  borderBottomColor: "#6C6C6C33",
                                  borderBottomWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                className="p-0"
                              >
                                <div
                                  className=""
                                  style={{ textAlignLast: "center" }}
                                >
                                  {items?.freightAmount || "0"}
                                </div>
                              </td>
                              <td
                                style={{
                                  width: "25%",
                                  borderLeft: "1px solid transparent",
                                  borderRight: " 1px solid transparent",
                                  justifyContent: "center",
                                  alignContent: "center",
                                  borderBottomColor: "#6C6C6C33",
                                  borderBottomWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                className="p-0"
                              >
                                <div className="d-flex justify-content-center">
                                  <div
                                    className=""
                                    style={{
                                      textAlignLast: "center",
                                      color: "white",
                                      backgroundColor: "#4D5073",
                                      borderRadius: "5px",
                                      padding: "4px",
                                      paddingLeft: "8px",
                                      paddingRight: "8px",
                                    }}
                                  >
                                    Payment Entry
                                  </div>
                                </div>
                              </td>
                              <td
                                style={{
                                  width: "5%",
                                  borderLeft: "1px solid transparent",
                                  borderRight: " 1px solid transparent",
                                  borderBottomColor: "#6C6C6C33",
                                  borderBottomWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                className="p-0"
                                onClick={() => {
                                  removeSelectedRow(index);
                                }}
                              >
                                <SvgImage name="deleteIcon2" />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
              <FormGroup
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  gap: "50px",
                }}
              >
                <FormGroup>
                  <label for="vrn" className="heading3 semiBold">
                    From
                  </label>
                  <div className="custNamepadd3">
                    <input
                      className={`inputBoxCust1 ${
                        touched.source && errors.source ? "is-invalid" : ""
                      }`}
                      type="text"
                      autocomplete="off"
                      name="source"
                      id="source"
                      placeholder={"Source City"}
                      aria-label="Default select example"
                      onChange={(e) => {
                        setDisplay1(true);
                        setSearch1(e.target.value);
                        setFieldValue("source", e.target.value, true);
                      }}
                      onClick={() => {
                        setDisplay1(true);
                      }}
                      value={values.source}
                      autoComplete="off"
                      onBlur={handleBlur("source")}
                      errors={errors.source}
                      touched={touched.source}
                      onKeyUp={(e) => {
                        if (e.key === "Enter") {
                          // findSearch1();
                        }
                      }}
                    />
                  </div>
                  {display1 ? (
                    <div
                      className="padding16 newCashback whiteBackground"
                      style={{
                        position: "absolute",
                        width: "350px",
                        height: "275px",
                        zIndex: "90",
                      }}
                    >
                      <div
                        onClick={() => {
                          setDisplay1(false);
                          setSearch1("");
                          //dispatch(clearAllDriversByVrn());
                          // setFieldValue("source", "", true);
                          // setFieldValue("sourceId", "", true);
                        }}
                        style={{
                          position: "absolute",
                          right: "0.5rem",
                          top: "0.5rem",
                          cursor: "pointer",
                        }}
                      >
                        <SvgImage name="CloseButtonLogo" />
                      </div>
                      <div
                        style={{
                          overflowY: "scroll",
                          overflowX: "hidden",
                          height: "240px",
                        }}
                      >
                        {console.log(
                          "savedAddresses11111",
                          search1,
                          savedAddresses
                        )}
                        {search1 == "" ? (
                          savedAddresses?.map((data, i) => {
                            let city = data?.cityName;
                            let state = data?.stateName;
                            let address = data?.address;
                            console.log(
                              "savedAddresses",
                              city,
                              state,
                              address,
                              data
                            );
                            return (
                              <div
                                key={i}
                                className="padding8 row"
                                onClick={() => {
                                  // setcityId1(data?.cityName);
                                  setColor1(i);
                                  setDisplay1(false);
                                  //setUserId(data?.User?.userId);
                                  setFieldValue(
                                    "sourceId",
                                    data?.addressId,
                                    true
                                  );
                                  setFieldValue(
                                    "source",
                                    `${address}, ${city} - ${state}`,
                                    true
                                  );
                                  setSourcePincode(data?.pincode);
                                  console.log(
                                    "kkjjjjj",
                                    destPincode,
                                    data?.pincode
                                  );
                                  if (destPincode && data?.pincode) {
                                    console.log("kkjjjjj");
                                    dispatch(
                                      getDistance(
                                        {
                                          source: data?.pincode,
                                          des: destPincode,
                                        },
                                        (res) => {
                                          if (res?.status == 200) {
                                            console.log(
                                              "ppssspppppppp",
                                              res?.data?.data?.distanceCal
                                            );
                                            // setDistanceCal(res?.data?.data?.distanceCal)
                                            setFieldValue(
                                              "expectedDistanceKM",
                                              parseFloat(
                                                res?.data?.data?.distanceCal
                                              )?.toFixed(2),
                                              true
                                            );
                                          }
                                        }
                                      )
                                    );
                                  }
                                }}
                              >
                                {color1 === i ? (
                                  <div className="col-1">
                                    <SvgImage name="SelectedRadio" />
                                  </div>
                                ) : (
                                  <div className="col-1">
                                    <SvgImage name="UnselectedRadio" />
                                  </div>
                                )}
                                {/* <div className="col-1">
                      <SvgImage name="UnselectedRadio" />
                    </div> */}
                                <div
                                  className="col-11"
                                  style={{ textAlign: "left" }}
                                >
                                  {address}, {city} - {state}
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <>
                            {savedAddresses?.map((data, i) => {
                              let city = data?.cityName;
                              let state = data?.stateName;
                              let address = data?.address;

                              console.log("check status", city, state);
                              // let cardStatus=Number(data?.WalletAccount?.accountStatus);
                              return (
                                <div
                                  key={i}
                                  className="padding8 row"
                                  onClick={() => {
                                    // setcityId1(data?.cityName);
                                    setColor1(i);
                                    setDisplay1(false);
                                    //setUserId(data?.User?.userId);
                                    setFieldValue(
                                      "sourceId",
                                      data?.addressId,
                                      true
                                    );
                                    setFieldValue(
                                      "source",
                                      `${address}, ${city} - ${state}`,
                                      true
                                    );
                                    setSourcePincode(data?.pincode);
                                    if (destPincode && data?.pincode) {
                                      dispatch(
                                        getDistance(
                                          {
                                            source: data?.pincode,
                                            des: destPincode,
                                          },
                                          (res) => {
                                            if (res?.status == 200) {
                                              console.log(
                                                "ppssspppppppp",
                                                res?.data?.data?.distanceCal
                                              );
                                              // setDistanceCal(res?.data?.data?.distanceCal)
                                              setFieldValue(
                                                "expectedDistanceKM",
                                                parseFloat(
                                                  res?.data?.data?.distanceCal
                                                )?.toFixed(2),
                                                true
                                              );
                                            }
                                          }
                                        )
                                      );
                                    }
                                  }}
                                >
                                  {color1 === i ? (
                                    <div className="col-1">
                                      <SvgImage name="SelectedRadio" />
                                    </div>
                                  ) : (
                                    <div className="col-1">
                                      <SvgImage name="UnselectedRadio" />
                                    </div>
                                  )}
                                  <div
                                    className="col-11"
                                    style={{ textAlign: "left" }}
                                  >
                                    {address}, {city} - {state}
                                  </div>
                                </div>
                              );
                            })}
                          </>
                        )}
                        {savedAddresses?.length == 0 ? (
                          <div className="">
                            <div style={{ margin: "24px" }}>
                              You have no addresses to select please add a new
                              one
                            </div>
                            <div className="d-flex justify-content-center">
                              <div
                                className="greenButton d-flex justify-content-center align-items-center"
                                style={{
                                  width: "200px",
                                  cursor: "pointer",
                                }}
                                onClick={addAddress}
                              >
                                <div>Add New Address</div>
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}

                  <div style={{ margin: "7px 0 0px 0px", color: "red" }}>
                    {errors.source && touched.source ? (
                      <div>*{errors.source}</div>
                    ) : null}
                  </div>
                </FormGroup>
                <div
                  style={{
                    alignContent: "center",
                    textDecorationLine: "underline",
                    cursor: "pointer",
                    marginRight: "110px",
                  }}
                  onClick={addAddress}
                >
                  + Add Address
                </div>

                <FormGroup>
                  <label for="vrn" className="heading3 semiBold">
                    To
                  </label>
                  <div className="custNamepadd3">
                    <input
                      className={`inputBoxCust1 ${
                        touched.destination && errors.destination
                          ? "is-invalid"
                          : ""
                      }`}
                      type="text"
                      touched={touched.destination}
                      placeholder="Select destination"
                      autocomplete="off"
                      // onFocus={() => {}}
                      name="destination"
                      id="destination"
                      aria-label="Default select example"
                      onClick={() => {
                        setDisplay2(true);
                      }}
                      onChange={(e) => {
                        setDisplay2(true);
                        setSearch2(e.target.value);
                        setFieldValue("destination", e.target.value, true);
                      }}
                      value={values.destination}
                      autoComplete="off"
                      onBlur={handleBlur("destination")}
                      errors={errors.destination}
                      onKeyUp={(e) => {
                        if (e.key === "Enter") {
                          // findSearch2();
                        }
                      }}
                    />
                  </div>
                  {display2 ? (
                    <div
                      className="padding16 newCashback whiteBackground"
                      style={{
                        position: "absolute",
                        width: "350px",
                        height: "275px",
                        zIndex: "90",
                      }}
                    >
                      <div
                        onClick={() => {
                          setDisplay2(false);
                          setSearch2("");
                          //dispatch(clearAllDriversByVrn());
                          // setFieldValue("destination", "", true);
                        }}
                        style={{
                          position: "absolute",
                          right: "0.5rem",
                          top: "0.5rem",
                          cursor: "pointer",
                        }}
                      >
                        <SvgImage name="CloseButtonLogo" />
                      </div>
                      <div
                        style={{
                          overflowY: "scroll",
                          overflowX: "hidden",
                          height: "240px",
                        }}
                      >
                        {search2 == "" ? (
                          savedAddresses?.map((data, i) => {
                            let city = data?.cityName;
                            let state = data?.stateName;
                            let address = data?.address;
                            return (
                              <div
                                key={i}
                                className="padding8 row"
                                onClick={() => {
                                  // setcityId2(data?.cityName);
                                  setColor2(i);
                                  setDisplay2(false);
                                  //setUserId(data?.User?.userId);
                                  setFieldValue(
                                    "destination",
                                    `${address}, ${city} - ${state}`,
                                    true
                                  );
                                  setFieldValue(
                                    "destId",
                                    data?.addressId,
                                    true
                                  );
                                  console.log(
                                    "llllllllkkk",
                                    sourcePincode,
                                    data?.pincode
                                  );
                                  setDestPincode(data?.pincode);
                                  if (sourcePincode && data?.pincode) {
                                    dispatch(
                                      getDistance(
                                        {
                                          source: sourcePincode,
                                          des: data?.pincode,
                                        },
                                        (res) => {
                                          if (res?.status == 200) {
                                            console.log(
                                              "ppssspppppppp",
                                              res?.data?.data?.distanceCal
                                            );
                                            setFieldValue(
                                              "expectedDistanceKM",
                                              parseFloat(
                                                res?.data?.data?.distanceCal
                                              )?.toFixed(2),
                                              true
                                            );
                                          }
                                        }
                                      )
                                    );
                                  }
                                }}
                              >
                                {color2 === i ? (
                                  <div className="col-1">
                                    <SvgImage name="SelectedRadio" />
                                  </div>
                                ) : (
                                  <div className="col-1">
                                    <SvgImage name="UnselectedRadio" />
                                  </div>
                                )}
                                {/* <div className="col-1">
                      <SvgImage name="UnselectedRadio" />
                    </div> */}
                                <div
                                  className="col-11"
                                  style={{ textAlign: "left" }}
                                >
                                  {address}, {city} - {state}
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <>
                            {savedAddresses?.map((data, i) => {
                              let city = data?.cityName;
                              let state = data?.stateName;
                              let address = data?.address;

                              console.log("check status", city, state);
                              // let cardStatus=Number(data?.WalletAccount?.accountStatus);
                              return (
                                <div
                                  key={i}
                                  className="padding8 row"
                                  onClick={() => {
                                    // setcityId2(data?.cityName);
                                    setColor2(i);
                                    setDisplay2(false);
                                    //setUserId(data?.User?.userId);
                                    setFieldValue(
                                      "destination",
                                      `${address}, ${city} - ${state}`,
                                      true
                                    );
                                    setFieldValue(
                                      "destId",
                                      data?.addressId,
                                      true
                                    );
                                    setDestPincode(data?.pincode);
                                    if (sourcePincode && data?.pincode) {
                                      dispatch(
                                        getDistance(
                                          {
                                            source: sourcePincode,
                                            des: data?.pincode,
                                          },
                                          (res) => {
                                            if (res?.status == 200) {
                                              console.log(
                                                "ppssspppppppp",
                                                res?.data?.data?.distanceCal
                                              );
                                              setFieldValue(
                                                "expectedDistanceKM",
                                                parseFloat(
                                                  res?.data?.data?.distanceCal
                                                )?.toFixed(2),
                                                true
                                              );
                                            }
                                          }
                                        )
                                      );
                                    }
                                  }}
                                >
                                  {color2 === i ? (
                                    <div className="col-1">
                                      <SvgImage name="SelectedRadio" />
                                    </div>
                                  ) : (
                                    <div className="col-1">
                                      <SvgImage name="UnselectedRadio" />
                                    </div>
                                  )}
                                  <div
                                    className="col-11"
                                    style={{ textAlign: "left" }}
                                  >
                                    {address}, {city} - {state}
                                  </div>
                                </div>
                              );
                            })}
                          </>
                        )}
                        {savedAddresses?.length == 0 ? (
                          <div className="">
                            <div style={{ margin: "24px" }}>
                              You have no addresses to select please add a new
                              one
                            </div>
                            <div className="d-flex justify-content-center">
                              <div
                                className="greenButton d-flex justify-content-center align-items-center"
                                style={{
                                  width: "200px",
                                  cursor: "pointer",
                                }}
                                onClick={addAddress}
                              >
                                <div>Add New Address</div>
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}

                  <div style={{ margin: "7px 0 0px 0px", color: "red" }}>
                    {errors.destination && touched.destination ? (
                      <div>*{errors.destination}</div>
                    ) : null}
                  </div>
                </FormGroup>
                <FormGroup>
                  <div
                    className="heading3 semiBold"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setShowStops(!showStops);
                    }}
                  >
                    Show Stops
                  </div>
                  <div>
                    {showStops ? (
                      <div
                        className="padding16 newCashback whiteBackground"
                        style={{
                          position: "absolute",
                          width: "350px",
                          height: "360px",
                          zIndex: "90",
                        }}
                      >
                        <div
                          onClick={() => {
                            setShowStops(false);
                          }}
                          style={{
                            textAlign: "right",
                            cursor: "pointer",
                            zIndex: 10,
                          }}
                        >
                          <SvgImage name="CloseButtonLogo" />
                        </div>
                        <div
                          style={{
                            overflowY: "scroll",
                            overflowX: "hidden",
                            height: "300px",
                            // backgroundColor: "red",
                          }}
                        >
                          <DragDropContext onDragEnd={handleDragEnd}>
                            <Droppable droppableId="droppable">
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.droppableProps}
                                >
                                  {list?.map((data, i) => {
                                    let city = data?.cityName;
                                    let state = data?.stateName;
                                    let address = data?.address;
                                    return (
                                      <Draggable
                                        key={data.addressId}
                                        index={i}
                                        draggableId={data.addressId}
                                      >
                                        {(provided, snapshot) => (
                                          <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            key={i}
                                            className="padding8 d-flex"
                                            onMouseDown={(e) =>
                                              e.preventDefault()
                                            }
                                            style={{
                                              ...provided.draggableProps.style,
                                              // customized drag style
                                              background: snapshot.isDragging
                                                ? "lightblue"
                                                : "transparent",
                                              padding: "8px 16px",
                                              // background: "lightblue",
                                              borderRadius: "16px",
                                              alignItems: "center",
                                            }}
                                            onClick={() => {}}
                                          >
                                            <div
                                              className=""
                                              style={{
                                                alignContent: "center",
                                              }}
                                            >
                                              <SvgImage name="drag" />
                                            </div>
                                            <div
                                              className=""
                                              style={{
                                                textAlign: "left",
                                                paddingLeft: 12,
                                              }}
                                            >
                                              {address}, {city} - {state}
                                            </div>
                                            <div
                                              style={{
                                                fontSize: "35px",
                                                cursor: "pointer",
                                              }}
                                              onClick={() => {
                                                let newData = [...list];
                                                newData?.splice(i, 1);
                                                setList(newData);
                                              }}
                                            >
                                              -
                                            </div>
                                          </div>
                                        )}
                                      </Draggable>
                                    );
                                  })}
                                  {addStop ? (
                                    <div>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "flex-start",
                                          padding: "8px 16px",
                                        }}
                                      >
                                        <div
                                          className=""
                                          style={{
                                            alignContent: "center",
                                          }}
                                        >
                                          <SvgImage name="drag" />
                                        </div>
                                        <input
                                          type="text"
                                          placeholder={"Add new Stop"}
                                          className={`form-control-1`}
                                          style={{ marginLeft: 12 }}
                                          aria-label="Default select example"
                                          onChange={(e) => {
                                            setDisplay3(true);
                                          }}
                                          onClick={() => {
                                            setDisplay3(true);
                                          }}
                                          value={
                                            newStop.address
                                              ? newStop.address +
                                                ", " +
                                                newStop.cityName +
                                                " - " +
                                                newStop.stateName
                                              : null
                                          }
                                          autoComplete="off"
                                          onKeyUp={(e) => {
                                            if (e.key === "Enter") {
                                              // findSearch2();
                                            }
                                          }}
                                          onBlur={(e) => {
                                            setDisplay3(false);
                                          }}
                                          onFocus={() => {
                                            setDisplay3(true);
                                          }}
                                        ></input>
                                      </div>
                                      {display3 ? (
                                        <div
                                          className="padding16 newCashback whiteBackground"
                                          style={{
                                            // position: "absolute",
                                            width: "300px",
                                            height: "275px",
                                            zIndex: "90",
                                          }}
                                        >
                                          {/* <div
                                                onClick={() => {
                                                  setDisplay3(false);
                                                  setSearch3("");
                                                  //dispatch(clearAllDriversByVrn());
                                                  // setFieldValue("destination", "", true);
                                                }}
                                                style={{
                                                  position: "absolute",
                                                  right: "0.5rem",
                                                  top: "0.5rem",
                                                  cursor: "pointer",
                                                }}
                                              >
                                                <SvgImage name="CloseButtonLogo" />
                                              </div> */}
                                          <div
                                            style={{
                                              overflowY: "scroll",
                                              overflowX: "hidden",
                                              height: "240px",
                                            }}
                                          >
                                            {search2 == "" ? (
                                              savedAddresses?.map((data, i) => {
                                                let city = data?.cityName;
                                                let state = data?.stateName;
                                                let address = data?.address;
                                                return (
                                                  <div
                                                    key={i}
                                                    className="padding8 row"
                                                    onMouseDown={(e) =>
                                                      e.preventDefault()
                                                    }
                                                    onClick={() => {
                                                      // setcityId2(data?.cityName);
                                                      setColor2(i);
                                                      setDisplay3(false);
                                                      setSearch3("");

                                                      setNewStop(data);
                                                    }}
                                                  >
                                                    {color2 === i ? (
                                                      <div className="col-1">
                                                        <SvgImage name="SelectedRadio" />
                                                      </div>
                                                    ) : (
                                                      <div className="col-1">
                                                        <SvgImage name="UnselectedRadio" />
                                                      </div>
                                                    )}
                                                    {/* <div className="col-1">
                      <SvgImage name="UnselectedRadio" />
                    </div> */}
                                                    <div
                                                      className="col-11"
                                                      style={{
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      {address}, {city} -{" "}
                                                      {state}
                                                    </div>
                                                  </div>
                                                );
                                              })
                                            ) : (
                                              <>
                                                {savedAddresses?.map(
                                                  (data, i) => {
                                                    let city = data?.cityName;
                                                    let state = data?.stateName;
                                                    let address = data?.address;

                                                    console.log(
                                                      "check status",
                                                      city,
                                                      state
                                                    );
                                                    // let cardStatus=Number(data?.WalletAccount?.accountStatus);
                                                    return (
                                                      <div
                                                        key={i}
                                                        className="padding8 row"
                                                        onMouseDown={(e) =>
                                                          e.preventDefault()
                                                        }
                                                        onClick={() => {
                                                          // setcityId2(data?.cityName);
                                                          setColor2(i);
                                                          setDisplay3(false);
                                                          //setUserId(data?.User?.userId);
                                                          setSearch3("");
                                                          setNewStop(data);
                                                        }}
                                                      >
                                                        {color2 === i ? (
                                                          <div className="col-1">
                                                            <SvgImage name="SelectedRadio" />
                                                          </div>
                                                        ) : (
                                                          <div className="col-1">
                                                            <SvgImage name="UnselectedRadio" />
                                                          </div>
                                                        )}
                                                        <div
                                                          className="col-11"
                                                          style={{
                                                            textAlign: "left",
                                                          }}
                                                        >
                                                          {address}, {city} -{" "}
                                                          {state}
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                )}
                                              </>
                                            )}
                                            {savedAddresses?.length == 0 ? (
                                              <div className="">
                                                <div style={{ margin: "24px" }}>
                                                  You have no addresses to
                                                  select please add a new one
                                                </div>
                                                <div className="d-flex justify-content-center">
                                                  <div
                                                    className="greenButton d-flex justify-content-center align-items-center"
                                                    style={{
                                                      width: "200px",
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={addAddress}
                                                  >
                                                    <div>Add New Address</div>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : null}
                                          </div>
                                        </div>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  ) : null}

                                  <div
                                    className="heading3 semiBold"
                                    style={{
                                      textAlign: "right",
                                      cursor: "pointer",
                                      marginTop: "12px",

                                      // zIndex: 10,
                                    }}
                                    onClick={() => {
                                      setAddStop(!addStop);
                                      if (addStop && newStop?.addressId) {
                                        let newData = [...list];
                                        newData.push(newStop);
                                        setList(newData);
                                      }
                                    }}
                                  >
                                    {addStop ? "Save" : "+ Add Stop"}
                                  </div>
                                </div>
                              )}
                            </Droppable>
                          </DragDropContext>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </FormGroup>
                <FormGroup>
                  <label for="vrn" className="heading3 semiBold">
                    Vehicle Number
                  </label>
                  <div className="custNamepadd3 d-flex">
                    <div>
                      <input
                        autocomplete="off"
                        className={`inputBoxCust1 ${
                          touched.vrn && errors.vrn ? "is-invalid" : ""
                        }`}
                        type="text"
                        id="vrn"
                        name="vrn"
                        touched={touched.vrn}
                        errors={errors.vrn}
                        onClick={() => {
                          setOpen(true);
                        }}
                        onBlur={() => {
                          handleBlur("driver");
                          // setOpen(false);
                        }}
                        onChange={(event) => {
                          setSearch(event.target.value);
                          setFieldValue("vrn", event.target.value, true);
                        }}
                        value={values.vrn}
                        // autoFocus
                        placeholder="Select Vehicle"
                      />
                      <div style={{ position: "relative" }}>
                        {open ? (
                          <div className="driverSearchContainer containerShadow">
                            <div
                              style={{
                                position: "absolute",
                                top: "0.3rem",
                                right: "0.3rem",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setOpen(false);
                              }}
                            >
                              <SvgImage name="CloseButtonLogo" />
                            </div>
                            {allFleets?.map((item, i) => {
                              return (
                                <>
                                  {/* {item?.Fastag !== null ? ( */}
                                  <div
                                    key={i}
                                    className="flexStyling padding8 "
                                    onClick={(event) => {
                                      setOpen(false);
                                      console.log("kkkkllll", item);
                                      setFieldValue(
                                        "vrn",
                                        item?.regNumber,
                                        true
                                      );
                                      setFieldValue(
                                        "fleetId",
                                        item?.fleetId,
                                        true
                                      );
                                      setFieldValue(
                                        "driver",
                                        item?.FleetDriverMapHistories?.length >
                                          0
                                          ? item?.FleetDriverMapHistories[0]
                                              ?.Driver?.User?.fullName
                                          : "",
                                        true
                                      );
                                      setdriverUserId(
                                        item?.FleetDriverMapHistories?.length >
                                          0
                                          ? item?.FleetDriverMapHistories[0]
                                              ?.Driver?.userId
                                          : ""
                                      );
                                      setFieldValue(
                                        "driverUserId",
                                        item?.FleetDriverMapHistories?.length >
                                          0
                                          ? item?.FleetDriverMapHistories[0]
                                              ?.Driver?.userId
                                          : "",
                                        true
                                      );
                                    }}
                                  >
                                    <input
                                      type="radio"
                                      name="vrn"
                                      value={item?.fleetId}
                                      id={item?.fleetId}
                                    />
                                    <div
                                      className="padding16L"
                                      value={item?.fleetId}
                                    >
                                      {item?.regNumber}
                                    </div>
                                  </div>
                                  {/* ) : (
                                    <></>
                                  )} */}
                                </>
                              );
                            })}
                            {vehCount == 0 ? (
                              <div className="heading3 semiBold padding16 padding24B">
                                No Vehicle Available
                              </div>
                            ) : (
                              // :
                              //  fastVeh == undefined ? (
                              //   <div className="heading3 semiBold padding16 padding24B">
                              //     No Vehicle Available
                              //   </div>
                              // )
                              <></>
                            )}
                          </div>
                        ) : (
                          <></>
                        )}

                        <div style={{ margin: "7px 0 0px 96px", color: "red" }}>
                          {errors.fleetId && touched.fleetId ? (
                            <div>*{errors.fleetId}</div>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        marginLeft: "30px",
                        cursor: "pointer",
                      }}
                      onClick={addVehicle}
                    >
                      <SvgImage name="addIoconV2" />
                    </div>
                  </div>
                </FormGroup>
              </FormGroup>
              <FormGroup
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  gap: "50px",
                }}
              >
                <FormGroup>
                  <label for="expectedStartTime" className="heading3 semiBold">
                    Expected Start Time
                  </label>
                  <div className="custNamepadd3">
                    <input
                      className={`inputBoxCust1 ${
                        touched.expectedStartTime && errors.expectedStartTime
                          ? "is-invalid"
                          : ""
                      }`}
                      type="datetime-local"
                      errors={errors.expectedStartTime}
                      autocomplete="off"
                      name="expectedStartTime"
                      id="expectedStartTime"
                      header="Select Start date"
                      value={values.expectedStartTime}
                      onChange={(v) => {
                        let endDate = v
                          ? new Date(v?.target?.value)
                          : new Date();
                        let newEndDate = routeData?.expectedTimeHR
                          ? new Date(
                              endDate.setHours(
                                endDate.getHours() + routeData?.expectedTimeHR
                              )
                            )
                          : "";
                        setFieldValue(
                          "expectedStartTime",
                          v?.target?.value,
                          true
                        );
                        setFieldValue("expectedEndTime", newEndDate, true);
                      }}
                    />
                    <div
                      className="heading4 Regular"
                      style={{ margin: "7px 0 0px 0", color: "red" }}
                    >
                      {errors.expectedStartTime && touched.expectedStartTime ? (
                        <div>*{errors.expectedStartTime}</div>
                      ) : null}
                    </div>
                  </div>
                </FormGroup>
                <FormGroup>
                  <label for="expectedEndTime" className="heading3 semiBold">
                    Expected End Time
                  </label>
                  <div className="custNamepadd3">
                    <input
                      className={`inputBoxCust1 ${
                        touched.expectedEndTime && errors.expectedEndTime
                          ? "is-invalid"
                          : ""
                      }`}
                      type="datetime-local"
                      id="expectedEndTime"
                      name="expectedEndTime"
                      touched={touched.expectedEndTime}
                      errors={errors.expectedEndTime}
                      value={values.expectedEndTime}
                      // autoFocus
                      placeholder="Select From"
                      autocomplete="off"
                      onChange={(v) => {
                        setFieldValue(
                          "expectedEndTime",
                          v?.target?.value,
                          true
                        );
                      }}
                    />
                  </div>
                </FormGroup>
                <FormGroup>
                  <label for="expectedDistanceKM" className="heading3 semiBold">
                    Expected Distance(KMs)
                  </label>
                  <div className="custNamepadd3">
                    <input
                      className={`inputBoxCust1 ${
                        touched.expectedDistanceKM && errors.expectedDistanceKM
                          ? "is-invalid"
                          : ""
                      }`}
                      type="text"
                      autocomplete="off"
                      id="expectedDistanceKM"
                      name="expectedDistanceKM"
                      onChange={(event) => {
                        // setSearch(event.target.value);
                        setFieldValue(
                          "expectedDistanceKM",
                          event.target.value,
                          true
                        );
                      }}
                      value={values.expectedDistanceKM}
                      touched={touched.expectedDistanceKM}
                      errors={errors.expectedDistanceKM}
                      placeholder="Enter Expected Distance"
                    />
                  </div>
                </FormGroup>
                <FormGroup>
                  <label for="vrn" className="heading3 semiBold">
                    Driver Name
                  </label>
                  <div className="custNamepadd3 d-flex">
                    <div>
                      <input
                        type="text"
                        className={`inputBoxCust1 ${
                          touched.tripNo && errors.tripNo ? "is-invalid" : ""
                        }`}
                        autocomplete="off"
                        id="driver"
                        name="driver"
                        touched={touched.driver}
                        errors={errors.driver}
                        onBlur={() => {
                          handleBlur("driver");
                        }}
                        onClick={() => {
                          setOpen1(true);
                        }}
                        autoComplete="off"
                        onChange={(event) => {
                          setSearchDriver(event.target.value);
                          setFieldValue("driver", event.target.value, true);
                        }}
                        value={values.driver}
                        placeholder="Select Driver"
                      />
                      <div style={{ position: "relative" }}>
                        {open1 ? (
                          <div className="driverSearchContainer containerShadow">
                            <div
                              style={{
                                position: "absolute",
                                top: "0.3rem",
                                right: "0.3rem",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setOpen1(false);
                              }}
                            >
                              <SvgImage name="CloseButtonLogo" />
                            </div>
                            {driverList?.map((item, i) => {
                              return (
                                <>
                                  {item?.Fastag !== null ? (
                                    <div
                                      key={i}
                                      className="flexStyling padding8 "
                                      onClick={(event) => {
                                        setFieldValue(
                                          "driver",
                                          item?.User?.fullName,
                                          true
                                        );
                                        console.log("itemadas", item);
                                        setdriverUserId(item?.User?.userId);
                                        setFieldValue(
                                          "driverUserId",
                                          item?.User?.userId,
                                          true
                                        );
                                        // setOpen1(false);
                                      }}
                                    >
                                      <input
                                        type="radio"
                                        name="driver"
                                        value={item?.User?.userId}
                                        id={item?.User?.userId}
                                      />
                                      <div className="padding16L">
                                        {item?.User?.fullName.length > 35
                                          ? item?.User?.fullName.split(0, 35) +
                                            "..."
                                          : item?.User?.fullName}
                                      </div>
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                </>
                              );
                            })}
                            {driverCount == 0 ? (
                              <div className="heading3 semiBold padding16 padding24B">
                                No driver Available
                              </div>
                            ) : driverCount == undefined ? (
                              <div className="heading3 semiBold padding16 padding24B">
                                No driver Available
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                        ) : (
                          <></>
                        )}
                        <div style={{ margin: "7px 0 0px 96px", color: "red" }}>
                          {errors.driverUserId && touched.driverUserId ? (
                            <div>*{errors.driverUserId}</div>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        marginLeft: "30px",
                        cursor: "pointer",
                      }}
                      onClick={addDriver}
                    >
                      <SvgImage name="addIoconV2" />
                    </div>
                  </div>
                </FormGroup>
              </FormGroup>
              <div
                className="d-flex justify-content-between"
                style={{ alignItems: "center" }}
              >
                <div style={{ width: "65%" }}>
                  <div
                    className="PGCollectiontText col-9"
                    style={{ fontSize: "20px" }}
                  >
                    Payment Details
                  </div>
                  <Formik
                    // isValid='true'
                    enableReinitialize
                    // validationSchema={validationSchema}
                    initialValues={{
                      fuelWalletAmount: routeData?.fuelAdvance || "",
                      expectedFuelLiter: routeData?.fuelExpected || "",
                      fuelPaymentType: "Diesel Wallet",
                      advanceDriver: routeData?.sDriverAdvance || "",
                      driverSalary: routeData?.sDriverExpected || "",
                      driverIncentive: "",
                      driverPaymentType: "Salary",
                      fastagAmount: routeData?.fastagAdvance || "",
                      expactedFastagUses: routeData?.fastagExpected || "",
                      vendorAmount: "",
                      vendorIncentive: "",
                      totalVendorExpanse: "",
                      cashExpanceData: [
                        {
                          givenTo: "driver",
                          expanseType: "",
                          amount: routeData?.cashExpected || "",
                        },
                      ],
                    }}
                    onSubmit={(values) => {
                      // setState(1);

                      console.log("onSubmitonSubmit", values);
                    }}
                  >
                    {({
                      handleBlur,
                      handleChange,
                      handleSubmit,
                      setFieldValue,
                      values,
                      touched,
                      isValid,
                      errors,
                    }) => (
                      <Form
                        onSubmit={handleSubmit}
                        style={{ marginTop: "20px" }}
                      >
                        <Table
                          className="TripSectionTable"
                          bordered="true"
                          id="driver_tables" //
                          style={{ marginTop: "20px" }}
                        >
                          <thead>
                            <tr className="table-header-trip p-0 align-middle text-center">
                              {/* <th className="p-0" style={{ width: "15%" }}>
                              <div style={{ textAlignLast: "center" }}>For</div>{" "}
                            </th> */}
                              <th
                                className="p-0"
                                style={{
                                  width: "5%",
                                  textAlignLast: "center",
                                }}
                              ></th>
                              <th
                                className="p-0"
                                style={{
                                  width: "20%",
                                  textAlignLast: "center",
                                }}
                              >
                                Expense Header
                              </th>
                              <th
                                className="p-0"
                                style={{
                                  width: "25%",
                                  textAlignLast: "center",
                                }}
                              >
                                Via.
                              </th>
                              <th
                                className="p-0"
                                style={{
                                  width: "25%",
                                  textAlignLast: "center",
                                }}
                              >
                                Expected Expense
                              </th>
                              <th
                                className="p-0"
                                style={{
                                  width: "25%",
                                  textAlignLast: "center",
                                }}
                              >
                                Trip Advance
                              </th>
                              <th
                                className="p-0"
                                style={{
                                  width: "20%",
                                  textAlignLast: "center",
                                }}
                              >
                                Auto Advance
                              </th>
                              <th
                                className="p-0"
                                style={{
                                  width: "25%",
                                  textAlignLast: "center",
                                }}
                              >
                                Auto Settlement
                              </th>
                            </tr>
                          </thead>
                          <tbody className="lowerBorderLineCust">
                            {advancePayment?.map((items, index) => {
                              console.log("---------sdasdadadadasd--", items);
                              let type = items?.type;
                              return (
                                <tr
                                  className="table-row-manage-trip-new text4 align-middle text-center p-0"
                                  id="addr0"
                                  key={index}
                                  onClick={() => {
                                    // window.location = "/Customers/" + 1;
                                    //   navigate("/Customers/" + 1);
                                  }}
                                >
                                  <td
                                    className="p-0"
                                    style={{
                                      width: "5%",
                                      borderLeft: "1px solid transparent",
                                      // alignContent: "end",
                                      textAlignLast: "end",
                                    }}
                                  >
                                    {index + 1}
                                  </td>
                                  <td
                                    style={{
                                      width: "20%",

                                      borderRight: " 1px solid transparent",
                                    }}
                                    className="p-0"
                                  >
                                    <div
                                      className=""
                                      style={{ textAlignLast: "center" }}
                                    >
                                      {" "}
                                      {items.header != "" ? (
                                        items.header
                                      ) : (
                                        <div
                                          // className="d-flex"
                                          style={{
                                            alignItems: "center",
                                            // justifyContent: "center",
                                          }}
                                        >
                                          <input
                                            type="text"
                                            className="minBox3"
                                            name="type"
                                            placeholder="Choose"
                                            value={type || ""}
                                            onClick={() => {
                                              setOpenHeader(true);
                                              setSelectedIndexHeader(index);
                                            }}
                                            onChange={(e) =>
                                              handleChangeField(index, e)
                                            }
                                            autoComplete="off"
                                          />

                                          {openHeader &&
                                          selectedIndexHeader == index ? (
                                            <div
                                              className="paymentTypeSelect containerShadow"
                                              style={{ width: "200px" }}
                                            >
                                              <div
                                                style={{
                                                  position: "absolute",
                                                  top: "0.3rem",
                                                  right: "0.3rem",
                                                  cursor: "pointer",
                                                }}
                                                onClick={() => {
                                                  setOpenHeader(false);
                                                }}
                                              >
                                                <SvgImage name="CloseButtonLogo" />
                                              </div>
                                              {paymentTypeV2?.map((item, i) => {
                                                return (
                                                  <>
                                                    {/* {item?.Fastag !== null ? ( */}
                                                    <div
                                                      key={i}
                                                      className="flexStyling padding8"
                                                      onClick={(event) => {
                                                        handleChangeField(
                                                          index,
                                                          event
                                                        );
                                                        setOpenHeader(false);
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        name="type"
                                                        onChange={(e) =>
                                                          handleChangeField(
                                                            index,
                                                            e
                                                          )
                                                        }
                                                        value={item}
                                                        // checked={
                                                        //   item?.value == type
                                                        // }
                                                        id={item}
                                                        autoComplete={"off"}
                                                        disabled={
                                                          item != "Cash" &&
                                                          advancePayment?.find(
                                                            (e) =>
                                                              e?.header == item
                                                          )
                                                            ? true
                                                            : false
                                                        }
                                                      />
                                                      <div
                                                        className="padding16L"
                                                        value={item}
                                                      >
                                                        {item}
                                                      </div>
                                                    </div>
                                                  </>
                                                );
                                              })}
                                            </div>
                                          ) : (
                                            <></>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      width: "25%",
                                      borderLeft: "1px solid transparent",
                                      borderRight: " 1px solid transparent",
                                    }}
                                    className="p-0"
                                  >
                                    <input
                                      type="text"
                                      className="minBox3"
                                      name="type"
                                      placeholder="Choose a type"
                                      value={type || ""}
                                      onClick={() => {
                                        setOpen2(true);
                                        setSelectedIndex(index);
                                      }}
                                      onChange={(e) =>
                                        handleChangeField(index, e, "type")
                                      }
                                      autoComplete="off"
                                      disabled={
                                        items.header == "Driver" &&
                                        balanceRecord?.accountStatus != 4
                                          ? true
                                          : false
                                      }
                                    />
                                    {open2 && selectedIndex == index ? (
                                      <div
                                        className="paymentTypeSelect containerShadow"
                                        style={{ width: "200px" }}
                                      >
                                        <div
                                          style={{
                                            position: "absolute",
                                            top: "0.3rem",
                                            right: "0.3rem",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            setOpen2(false);
                                          }}
                                        >
                                          <SvgImage name="CloseButtonLogo" />
                                        </div>
                                        {paymentType[items.header]?.map(
                                          (item, i) => {
                                            return (
                                              <>
                                                {/* {item?.Fastag !== null ? ( */}
                                                <div
                                                  key={i}
                                                  className="flexStyling padding8"
                                                  onClick={(event) => {
                                                    handleChangeField(
                                                      index,
                                                      event,
                                                      "type"
                                                    );
                                                    setOpen2(false);
                                                  }}
                                                >
                                                  <input
                                                    type="radio"
                                                    name="type"
                                                    onChange={(e) =>
                                                      handleChangeField(
                                                        index,
                                                        e,
                                                        "type"
                                                      )
                                                    }
                                                    value={item?.value}
                                                    checked={
                                                      item?.value == type
                                                    }
                                                    id={item?.value}
                                                    autoComplete={"off"}
                                                  />
                                                  <div
                                                    className="padding16L"
                                                    value={item?.value}
                                                  >
                                                    {item?.value}
                                                  </div>
                                                </div>
                                              </>
                                            );
                                          }
                                        )}
                                      </div>
                                    ) : (
                                      <></>
                                    )}
                                  </td>
                                  {/* <td
                                  style={{
                                    width: "25%",
                                    borderLeft: "1px solid transparent",
                                    borderRight: " 1px solid transparent",
                                  }}
                                  className="p-0"
                                >
                                  <div
                                    className="d-flex"
                                    style={{ alignItems: "center" }}
                                  >
                                    {items.header == "Cash" &&
                                    type == "Vendor" ? (
                                      <div style={{ marginRight: "6px" }}>
                                        Vendor
                                      </div>
                                    ) : null}

                                    <input
                                      type="text"
                                      className="minBox3"
                                      name="vendorId"
                                      style={{
                                        width:
                                          items.header == "Cash" &&
                                          type == "Vendor"
                                            ? "70%"
                                            : "90%",
                                      }}
                                      placeholder={
                                        type == "Vendor"
                                          ? "Pick a vendor"
                                          : "Not Required"
                                      }
                                      onClick={() => {
                                        setSelectVendorModal(true);
                                        setSelectedIndex(index);
                                      }}
                                      disabled={type == "Vendor" ? false : true}
                                      value={items?.vendor?.name || ""}
                                      // onChange={(e) => handleChangeField(index, e)}
                                    />
                                  </div>
                                </td> */}
                                  <td
                                    style={{
                                      width: "25%",
                                      borderLeft: "1px solid transparent",
                                      borderRight: " 1px solid transparent",
                                    }}
                                    className="p-0"
                                  >
                                    <input
                                      type="number"
                                      className="minBox3"
                                      name="expacted"
                                      placeholder="₹ 0"
                                      value={items.expacted || ""}
                                      onChange={(e) =>
                                        handleChangeField(index, e, "expacted")
                                      }
                                      disabled={
                                        items.header == "Driver" &&
                                        balanceRecord?.accountStatus != 4
                                          ? true
                                          : false
                                      }
                                    />
                                  </td>

                                  <td
                                    style={{
                                      width: "20%",
                                      borderLeft: "1px solid transparent",
                                      borderRight: " 1px solid transparent",
                                    }}
                                    className="p-0"
                                  >
                                    <input
                                      type="number"
                                      className="minBox3"
                                      name="advance"
                                      placeholder="₹ 0"
                                      value={items.advance || ""}
                                      onChange={(e) =>
                                        handleChangeField(index, e, "advance")
                                      }
                                      disabled={
                                        items.header == "Driver" &&
                                        balanceRecord?.accountStatus != 4
                                          ? true
                                          : false
                                      }
                                    />
                                  </td>
                                  <td
                                    style={{
                                      width: "20%",
                                      borderLeft: "1px solid transparent",
                                      borderRight: " 1px solid transparent",
                                      justifyContent: "center",
                                    }}
                                    className="p-0"
                                  >
                                    <div
                                      className="d-flex"
                                      style={{
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      {/* <Switch
                                  checked={true}
                                  // onChange={(e) => {
                                  //   if (accountStatus == 4) {
                                  //     setCard(!card);
                                  //   }
                                  // }}
                                  handleDiameter={20}
                                  height={15}
                                  width={40}
                                  id="material-switch"
                                /> */}
                                      <MaterialUISwitch
                                        sx={{ m: 1 }}
                                        // defaultChecked
                                        checked={items?.autoFinal}
                                        disabled={
                                          (items.header == "Driver" &&
                                            balanceRecord?.accountStatus !=
                                              4) ||
                                          tripData?.isActive > 1
                                            ? true
                                            : false
                                        }
                                        value={items?.autoFinal}
                                        onChange={(e) => {
                                          console.log("kkjjjjjjj", e, items);
                                          e.target.value = e.target.checked;
                                          handleChangeField(
                                            index,
                                            e,
                                            "autoFinal"
                                          );
                                        }}
                                      />
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      width: "25%",
                                      borderLeft: "1px solid transparent",
                                      borderRight: " 1px solid transparent",
                                      justifyContent: "center",
                                    }}
                                    className="p-0"
                                  >
                                    <div
                                      className="d-flex"
                                      style={{
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      {/* <Switch
                                  checked={true}
                                  // onChange={(e) => {
                                  //   if (accountStatus == 4) {
                                  //     setCard(!card);
                                  //   }
                                  // }}
                                  handleDiameter={20}
                                  height={15}
                                  width={40}
                                  id="material-switch"
                                /> */}
                                      <MaterialUISwitch
                                        sx={{ m: 1 }}
                                        // defaultChecked
                                        checked={items?.autoAdvance}
                                        disabled={
                                          (items.header == "Driver" &&
                                            balanceRecord?.accountStatus !=
                                              4) ||
                                          tripData?.isActive > 2
                                            ? true
                                            : false
                                        }
                                        value={items?.autoAdvance}
                                        onChange={(e) => {
                                          console.log("kkjjjjjjj", e);
                                          e.target.value = e.target.checked;
                                          handleChangeField(
                                            index,
                                            e,
                                            "autoAdvance"
                                          );
                                        }}
                                      />
                                    </div>
                                  </td>
                                  {items.header != "Driver" ? (
                                    <td
                                      style={{
                                        width: "5%",
                                        borderLeft: "1px solid transparent",
                                        borderRight: " 1px solid transparent",
                                      }}
                                      className="p-0"
                                      onClick={() => {
                                        removeFormFields(index);
                                      }}
                                    >
                                      <SvgImage name="deleteIcon2" />
                                    </td>
                                  ) : null}
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                        <div className="d-flex justify-content-center">
                          <div className="addItemDiv3" onClick={addFormFields}>
                            + Add Other Payments
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
                <div
                  style={{
                    backgroundColor: "#E572311A",

                    borderRadius: "12px",
                    boxShadow: "0px 4px 4px 0px #00000040",
                    width: "30%",
                  }}
                >
                  <div
                    style={{
                      fontWeight: 600,
                      fontSize: "18px",
                      padding: "16px",
                      paddingBottom: "0px",
                    }}
                  >
                    Trip Calculator
                  </div>
                  <div style={{ padding: "16px", paddingTop: "0px" }}>
                    <div
                      className="d-flex justify-content-between"
                      style={{ marginTop: "10px" }}
                    >
                      <div style={{ fontWeight: 600, fontSize: "16px" }}>
                        Revenue
                      </div>
                      <div
                        style={{
                          fontWeight: 700,
                          fontSize: "16px",
                          color: "#09BD7B",
                        }}
                      >
                        ₹{Earnings}
                      </div>
                    </div>
                    <div
                      className="d-flex justify-content-between"
                      style={{ marginTop: "10px" }}
                    >
                      <div style={{ fontWeight: 600, fontSize: "16px" }}>
                        Expenses
                      </div>
                      <div
                        style={{
                          fontWeight: 700,
                          fontSize: "16px",
                          color: "#E63946",
                        }}
                      >
                        ₹{Expenses}
                      </div>
                    </div>
                    {advancePayment?.map((item, index) => {
                      return (
                        <div>
                          <div
                            className="d-flex justify-content-between"
                            style={{ marginTop: "8px" }}
                          >
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: "16px",
                                marginLeft: "24px",
                              }}
                            >
                              - {item?.header}
                            </div>
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: "16px",
                                // color: "#E63946",
                              }}
                            >
                              - ₹{item?.expacted}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div
                    style={{
                      height: "1px",
                      backgroundColor: "#6C6C6C80",
                      width: "100%",
                    }}
                  />
                  <div style={{ padding: "16px", paddingTop: "8px" }}>
                    <div
                      className="d-flex justify-content-between"
                      style={{ marginTop: "8px" }}
                    >
                      <div style={{ fontWeight: 600, fontSize: "18px" }}>
                        Net Earnings
                      </div>
                      <div
                        style={{
                          fontWeight: 700,
                          fontSize: "20px",
                          color:
                            Earnings - Expenses > 0 ? "#09BD7B" : "#E63946",
                        }}
                      >
                        ₹{Earnings - Expenses}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {freight ? (
                <AddLr
                  toggle={addFreight}
                  freight={freight}
                  location={"/trips/"}
                  onSubmit={(lrList) => {
                    addFreight();
                    setSelectedRow(lrList);
                  }}
                  // fleetId={}
                  onSubmit2={(lrList) => {
                    setSelectedRow(lrList);
                  }}
                  trip={"1"}
                />
              ) : null}
              {chooseRouteModal ? (
                <ChooseRoute
                  toggle={chooseRouteModalToggle}
                  createTrip={createTripModalToggle}
                  modal={chooseRouteModal}
                  // setPaymentDetailsModal={setPaymentDetailsModal}
                  setModal={setChooseRouteModal}
                  setRouteData={(data) => {
                    setFieldValue("routeName", data.name, true);
                    setRouteData(data);
                  }}
                  // location={"/lr/"}
                />
              ) : null}
            </Form>
          )}
        </Formik>
      </div>
      <AddAddress
        toggle={addAddress}
        address={addressModal}
        setAddress={setAddressModal}
      />
      <AddDriverV2 toggle={addDriver} freight={driver} />
      <AddVehicleV2 toggle={addVehicle} freight={vehicle} />
    </div>
  );
}

export default CreateTrip;
